// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__YxMPo","menu__line":"styles_menu__line__cbVhq","menu__line--light":"styles_menu__line--light__cIyQh","menu--open":"styles_menu--open__AVqj7"};